<h3 mat-dialog-title="" translate="" [translateParams]="{value: message}">Are you sure you want to delete ...?</h3>
<mat-dialog-actions class="flex justify-start content-center items-center flex-row gap-[1rem]">
  <button mat-flat-button="" color="warn" [mat-dialog-close]="true"><span translate="">Yes</span></button>
  <button mat-stroked-button="" [mat-dialog-close]="false" cdkFocusInitial=""><span translate="">No</span></button>
</mat-dialog-actions>